import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Chip from '@material-ui/core/Chip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { withStyles } from '@material-ui/core/styles'

import Options from './Options'
import TagField from './TagField'


const styles = {
  root: {
    maxWidth: 240,
    marginTop: 30,
  },
  imageBackground: {
    width: 240,
    height: 190,
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  tileBar: {
    background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  tagField: {
    marginTop: -1,

    '& fieldset': {
      borderRadius: '0 0 0 3px',
    },
    '& button': {
      borderRadius: '0 0 3px 0',
    },
  },
  options: {
    right: 0,
    position: 'absolute',

    '& svg': {
      stroke: 'white',
    },
  },
}


const Folio = ({
  tags,
  viewed,
  is_hidden,
  classes,
  picture,
  onAddTag,
  onRemove,
  thumbnail,
  className,
  onDeleteTag,
  onVisibleChange,
}) => {
  const [tag, setTag] = useState('')
  const handleChange = e => setTag(e.target.value)
  const createOnDeleteTagHandler = tagToDelete => () => onDeleteTag(tagToDelete)
  const handleAddTag = () => {
    if (onAddTag) {
      onAddTag(tag)
    }

    setTag('')
  }

  const createOpenLink = url => () => window.open(url, '_blank')
  const imageUrl = thumbnail || picture

  return (
    <div className={classNames(className, classes.root)}>
      <GridListTile>
        <Options
          className={classes.options}
          items={[
            { label: 'Remove', onClick: onRemove }
          ]}
        />

        <div
          role="button"
          onClick={createOpenLink(picture)}
          className={classes.imageBackground}
          style={{ backgroundImage: `url(${imageUrl})` }}
        />

        <GridListTileBar
          className={classes.tileBar}
          title={<span style={{ color: 'transparent' }}>Title</span>}
          subtitle={<span>Viewed: {viewed}</span>}
          actionIcon={(
            <IconButton onClick={onVisibleChange}>
              {!is_hidden ? <VisibilityIcon color="primary" /> : <VisibilityOffIcon color="secondary" />}
            </IconButton>
          )}
        />
      </GridListTile>

      <TagField className={classes.tagField} value={tag} onChange={handleChange} placeholder="New tag" onClick={handleAddTag} />

      {Array.isArray(tags) && (
        <Grid container className="mt1">
          {tags.map(currentTag => (
            <Chip
              className="mt1 mr1"
              key={currentTag}
              label={currentTag}
              onDelete={createOnDeleteTagHandler(currentTag)}
            />
          ))}
        </Grid>
      )}
    </div>
  )
}


Folio.defaultProps = {
  viewed: 0,
  is_hidden: false,
  onDeleteTag: () => {},
}


Folio.propTypes = {
  viewed: PropTypes.number,
  picture: PropTypes.string,
  onAddTag: PropTypes.func,
  onRemove: PropTypes.func,
  is_hidden: PropTypes.bool,
  original: PropTypes.string,
  onDeleteTag: PropTypes.func,
  className: PropTypes.string,
  onVisibleChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
}


export default withStyles(styles)(Folio)
